import trim from 'lodash/trim';
import { splitDomains } from './split-domains';

const domainsRegexp =
  /^(https?:\/\/)?(?:[a-z0-9]([a-z0-9.-]{1,63})|(\d+\.\d+.\d+.\d+))(:\d{2,5})?$/i;

export const isDomains = (inputString) => {
  if (trim(inputString) === '*') return true;
  const invalidItems = splitDomains(inputString).filter((rawItem) => !domainsRegexp.test(rawItem));
  return !invalidItems.length;
};
